import { useQuery } from '@tanstack/react-query';
import { fetchCollectionGenres } from './apiFetchCollectionGenres';
import { GenresResponse } from '../../../../../store/api';
import { AgeCategory } from '../../../../../../models/AgeCategory';
import { LoanFormatState } from '../../../../../store/loanFormat/state';
import { AgeCategoryState } from '../../../../../store/ageCategory/state';

const COLLECTION_GENRES_QUERY = 'collectionGenres';

export const useCollectionGenres = ({
    loanFormat,
    ageCategory
}: {
    loanFormat: LoanFormatState;
    ageCategory?: AgeCategoryState;
}) => {
    ageCategory = ageCategory !== AgeCategory.ALL_AGES ? ageCategory : undefined;

    const query = useQuery<GenresResponse>([COLLECTION_GENRES_QUERY, { ageCategory, loanFormat: loanFormat.key }], () =>
        fetchCollectionGenres({
            ageCategory: ageCategory?.toString(),
            loanFormat: loanFormat.requestKey
        })
    );

    const [firstTopBucket] = query.data?.topBuckets ?? [];
    const [firstBucket] = query.data?.buckets ?? [];
    const defaultGenre = firstTopBucket?.key ?? firstBucket?.key;

    const hasGenres = (query.data?.topBuckets?.length ?? 0) + (query.data?.buckets?.length ?? 0) > 0;

    return { ...query, defaultGenre, hasGenres };
};
